import Link from 'next/link';

interface LogoProps {
  locale: string;
}

export function Logo({ locale }: LogoProps) {
  return (
    <Link
      href={`/${locale}`}
      className="flex flex-shrink-0 items-center gap-2"
      aria-label="Hummii"
    >
      {/* Bird icon - placed in front of the word mark */}
      <svg
        viewBox="0 0 117 99"
        className="h-10 w-auto text-[#67AD51]"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g clipPath="url(#logo-bird-clip)">
          <path
            d="M0.865027 -0.000175755C-0.20981 -0.10638 -0.332162 1.7699 0.742675 1.93805C7.01693 2.82309 20.6141 9.23963 23.8036 12.0983C30.3488 17.9661 33.0752 27.4271 33.0752 33.7551C33.0752 40.0831 31.0828 69.0591 35.1724 78.2989C45.6586 102.027 61.9997 98.8582 91.1601 98.8582C91.1601 98.8582 65.2591 84.3791 64.0707 49.5706C63.3804 28.7723 59.9461 17.2315 52.3436 11.1778C48.42 8.0625 42.6089 5.44278 28.2777 6.96504C19.1198 4.46925 10.6347 0.982213 0.865027 -0.000175755Z"
            fill="currentColor"
          />
          <path
            d="M116.616 3.71714C118.363 5.48721 114.466 29.9407 98.2647 51.8011C91.7283 60.6514 84.0471 67.953 76.296 72.3162C72.7435 64.5738 70.7955 56.176 70.5723 47.6414C70.4063 42.6233 70.0742 38.145 69.5674 34.1535C70.383 32.9735 71.2335 31.8406 72.119 30.7549C89.6485 8.90343 114.894 1.97362 116.616 3.71714Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="logo-bird-clip">
            <rect width="117" height="99" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {/* Word mark - hidden on mobile, shown from tablet up */}
      <span className="hidden text-4xl font-bold leading-none tracking-tight text-[#2A2A0F] md:inline">
        HUMMII
      </span>
    </Link>
  );
}
